import styled from "styled-components";

export const DrawerOptionsList = styled.ul`
  padding: 48px 24px 24px 24px;
  list-style-type: none;
  color: #0a5079;
  font-size: 16px;
  font-weight: 500;

  > li {
    margin-bottom: 24px;

    > div > div > div {
        color: #0a5079;
    }

    ul {
      list-style-type: none;
      color: #2786bd;
      margin-left: -36px;

      > li {
        margin-bottom: 24px;
      }
    }

    > div {
      box-shadow: none;
      > div {
        padding: 0px;
      }
    }
  }
`;
